/***
*
*   LINK
*   Routes a new view within the application router
*   Use this instead of <a> to avoid reloading the page
*
*   PROPS
*   url: the destination as defined in /app/app.js
*   title: link title
*   text: link text
*   btn: display a button
*   small: display a small button
*   className: apply a custom css class
*
**********/

import React from 'react';
import ClassNames from 'classnames';
import { NavLink } from 'react-router-dom';
import Style from '../button/button.module.scss';
import { Icon } from 'components/lib'

export function Link(props){

  const css = ClassNames([

    'link',
    props.className,
    props.btn && Style.btn,
    props.big && Style.big,
    props.small && Style.small,
    props.btnWhite && Style.btnWhite,
    props.btnBrand && Style.btnBrand

  ]);

  if (props.url.includes('http')){
    return (
      <a href={ props.url } title={ props.title } className={ css }>
      { props.text }
      </a>
    )
  }

  return(
    <NavLink
      exact to={ props.url }
      className={ css }
      title={ props.title }
      onClick={ (event) => props.locked ? event.preventDefault() : props.click ? props.click() : null }
      activeClassName='active'
      style={{ color: props.completed ? 'var(--df-background)' : null,  }}
    >
      
        { props.iconLinkLeft &&
          <Icon image={ props.iconLinkLeft } className={ Style.iconMarginLeft }/>
        }

        { props.children ? props.children : props.text }

        { props.iconLinkRight &&
          <Icon image={ props.iconLinkRight } className={ Style.iconMarginRight }/>
        }
        
    </NavLink>

  );
}
